import {Types} from "../actions/createAccountActions";
import _ from "lodash";
import ReactPixel from 'react-facebook-pixel';


import cleanDeep from 'clean-deep';


const defaultState = {
  leave: {}
};

const createAccountReducers = (state = defaultState, action) => {
  switch (action.type) {
    
    case Types.CREATE_ACCOUNT_CONTACT_LISTS: {
      let newState = {...state}

      newState.createAccount.inList = action.payload.lists
      newState.createAccount.webinars = action.payload.webinars

      return newState;
    }
    case Types.CREATE_ACCOUNT_SAVING_LEAD: {
      let newState = {...state}
      newState.createAccount.savingLead = true;

      const {noOfEmployees,organisation,name,surname,email} = action.data
      if(noOfEmployees){
        newState.createAccount.noOfEmployees = noOfEmployees;
      }
      if(organisation){
        newState.createAccount.organisation = organisation;
      }
      // user may not have an account hence we should save details for auto-fill on browser
      localStorage.setItem('userData',JSON.stringify(action.data))
      return newState;
    }
    case Types.CREATE_ACCOUNT_SAVED_LEAD: {
      let newState = {...state}
      newState.createAccount.savingLead = false;
      newState.createAccount.savedLead = true;

      if (action.payload.lists){
        newState.createAccount.inList = action.payload.lists
      }

      let dealValue = 200

      switch (newState.createAccount.noOfEmployees){
          case "1-5":
          case "6-10":
              dealValue = 200;
              break
          case "11-20":
              dealValue = 500;
              break
          case "21-40":
              dealValue = 1000;
              break
          case "41-80":
              dealValue = 2000;
              break
          case "81-200":
              dealValue = 4000;
              break
          case "200+":
              dealValue = 4000;
              break
          default:
              if(!isNaN(newState.createAccount.noOfEmployees)){
                  // estimated value don't feel like rounding if this ends up exact
                  dealValue = newState.createAccount.noOfEmployees * 12
              }
      }

      window.gtag('event', 'generate_lead', {
        'event_category' : 'engagement',
        'event_label' : action.label
      });

      window.gtag('event', 'conversion', {
          'send_to': 'AW-776797276/XPxgCIrytPgCENz4s_IC',
          'value': dealValue,
          'currency': 'EUR',
          // 'event_callback': callback
      });


      // track payroll guide download
      if (action.linkedInTrackingId){
        window.lintrk('track', { conversion_id: action.linkedInTrackingId });
      }

      ReactPixel.track('Lead',{
        currency: "EUR",
        value: dealValue,
        content_name: action.label
        // predicted_ltv: dealValue * 3,
      });

      return newState;
    }


    case Types.CREATE_ACCOUNT_CREATING: {
      let newState = {...state}
      newState.createAccount.creating = true;
      newState.createAccount.noOfEmployees = action.noOfEmployees;
      newState.createAccount.organisation = action.organisation;
      return newState;
    }
    case Types.CREATE_ACCOUNT_USER_CREATED: {
      let newState = {...state}
      newState.my.profile = action.payload.profile

      localStorage.setItem('userData',JSON.stringify(action.payload.profile))

      newState.createAccount.userCreated = true;

      if(newState.createAccount.userCreated && newState.createAccount.userUpdated && newState.createAccount.acLeadCreated && newState.createAccount.demoAccountCreated){
        newState.createAccount.creating = false;
      }

      let dealValue = 200

      switch (newState.createAccount.noOfEmployees){
          case "1-5":
          case "6-10":
              dealValue = 200;
              break
          case "11-20":
              dealValue = 500;
              break
          case "21-40":
              dealValue = 1000;
              break
          case "41-80":
              dealValue = 2000;
              break
          case "81-200":
              dealValue = 4000;
              break
          case "200+":
              dealValue = 4000;
              break
          default:
              if(!isNaN(newState.createAccount.noOfEmployees)){
                  // estimated value don't feel like rounding if this ends up exact
                  dealValue = newState.createAccount.noOfEmployees * 12
              }
      }

      window.gtag('event', 'sign_up', {
        'event_category' : 'engagement',
        'event_label' : 'email'
      });

      window.gtag('event', 'conversion', {
          'send_to': 'AW-776797276/PmpWCP_EivgCENz4s_IC',
          'value': dealValue,
          'currency': 'EUR',
          // 'event_callback': callback
      });

      
      ReactPixel.track('StartTrial',{
        currency: "EUR",
        value: dealValue,
        predicted_ltv: dealValue * 3,
      });

      window.lintrk('track', { conversion_id: 6084242 });


      return newState;
    }
    case Types.CREATE_ACCOUNT_USER_UPDATED: {
      let newState = {...state}
      newState.createAccount.userUpdated = true;
      if(newState.createAccount.userCreated && newState.createAccount.userUpdated && newState.createAccount.acLeadCreated && newState.createAccount.demoAccountCreated){
        newState.createAccount.creating = false;
      }

      const existingUserData = localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

      let updatedProfile = action.userData

      if (existingUserData){
        // keep existing data
        updatedProfile = {
          ...existingUserData,
          ...updatedProfile
        }
      }

      console.log('settingUserData',updatedProfile)
      // set user data used for AC tracking + other forms
      localStorage.setItem('userData',JSON.stringify(updatedProfile))

      return newState;
    }
    case Types.CREATE_ACCOUNT_AC_LEAD: {
      let newState = {...state}
      newState.createAccount.acLeadCreated = true;
      if(newState.createAccount.userCreated && newState.createAccount.userUpdated && newState.createAccount.acLeadCreated && newState.createAccount.demoAccountCreated){
        newState.createAccount.creating = false;
      }
      return newState;
    }
    case Types.CREATE_ACCOUNT_USER_CREATION_FAILED: {
      let newState = {...state}
      newState.createAccount.creating = false;
      newState.createAccount.error = action.error;
      return newState;

    }
    case Types.CREATE_ACCOUNT_DEMO_CREATED: {
      let newState = {...state}
      newState.createAccount.demoAccountCreated = true;
      if(newState.createAccount.userCreated && newState.createAccount.userUpdated && newState.createAccount.acLeadCreated && newState.createAccount.demoAccountCreated){
        newState.createAccount.creating = false;
      }
      return newState;

    }

    default:
      return state;
  }
};

export default createAccountReducers;